import React from 'react';

const NoDataComponent = () => (
  <div className='no-data-component'>
    <div></div>
    <p>{I18n.t('no_data_available')}</p>
  </div>
)

export default NoDataComponent;